import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Row, Alert } from 'react-bootstrap';
import Select, { MultiValue } from 'react-select';
import createAxiosInstance from '../../../services/axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const feriadosAxios = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/feriados');
const empregadoresAxios = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/empregadorController');

interface Empregador {
  id: number;
  nome: string;
}

interface SelectOption {
  value: number;
  label: string;
}

const FeriadosInclusaoComponent = () => {
  const [data, setData] = useState('');
  const [descricao, setDescricao] = useState('');
  const [tipo, setTipo] = useState('Nacional');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const navigate = useNavigate();
  const [empregadores, setEmpregadores] = useState<SelectOption[]>([]);
  const [selectedEmpregadores, setSelectedEmpregadores] = useState<MultiValue<SelectOption>>([]);

  useEffect(() => {
    const fetchEmpregadores = async () => {
      try {
        const response = await empregadoresAxios.get<Empregador[]>('/listarTodosEmpregadoresAtivos');
        const options = response.data.map(emp => ({
          value: emp.id,
          label: emp.nome
        }));
        setEmpregadores(options);
      } catch (err) {
        console.error("Erro ao buscar empregadores:", err);
        setErro("Não foi possível carregar a lista de empregadores.");
      }
    };

    fetchEmpregadores();
  }, []);

  const handleCriarFeriado = async () => {
    setMensagem('');
    setErro('');

    if (!data || !descricao || !tipo) {
      setErro('Preencha todos os campos obrigatórios.');
      return;
    }

    if (tipo === 'Regional' && selectedEmpregadores.length === 0) {
      setErro('Para feriados regionais, selecione ao menos um empregador.');
      return;
    }

    const payload = {
      data,
      descricao,
      tipo,
      empregadorIds: tipo === 'Regional' ? selectedEmpregadores.map(emp => emp.value) : []
    };

    try {
      await feriadosAxios.post('/postFeriados', payload); 
      navigate('/parametros-feriados', { state: { sucesso: 'Feriado criado com sucesso!' } });
    } catch (err: any) { 
      console.error(err);
      const errorMsg = err.response?.data?.message || 'Erro ao criar feriado.';
      setErro(errorMsg);
    }
  };

  return (
    <div className="position-relative m-md-3">
      <h5>Parâmetros Cartão &gt; Incluir Feriado</h5>

      <Row className="mb-3 mt-4">
        <Form.Group as={Col} md="3">
          <Form.Label>Data</Form.Label>
          <Form.Control type="date" value={data} onChange={(e) => setData(e.target.value)} />
        </Form.Group>
        <Form.Group as={Col} md="4">
          <Form.Label>Nome do Feriado</Form.Label>
          <Form.Control type="text" value={descricao} onChange={(e) => setDescricao(e.target.value)} placeholder="Ex: Natal, Independência" />
        </Form.Group>
        <Form.Group as={Col} md="3">
          <Form.Label>Tipo de feriado</Form.Label>
          <Form.Select value={tipo} onChange={(e) => setTipo(e.target.value)}>
            <option value="Nacional">Nacional</option>
            <option value="Regional">Regional</option>
          </Form.Select>
        </Form.Group>
      </Row>

      {tipo === 'Regional' && (
        <Row className="mb-3">
          <Form.Group as={Col} md="7">
            <Form.Label>Empregadores para vincular</Form.Label>
            <Select
              isMulti
              options={empregadores}
              className="basic-multi-select"
              classNamePrefix="select"
              value={selectedEmpregadores}
              onChange={(options) => setSelectedEmpregadores(options)}
              placeholder="Selecione um ou mais empregadores..."
              noOptionsMessage={() => 'Nenhum empregador encontrado'}
              isLoading={empregadores.length === 0 && !erro}
            />
          </Form.Group>
        </Row>
      )}

      <Row className="mb-4">
        <Col md="3">
          <Button onClick={handleCriarFeriado} id="App-button-cor-principal-escura">
            Criar Feriado
          </Button>
        </Col>
        <Col md="3">
          <Button variant="secondary" onClick={() => navigate('/parametros-feriados')}>
            Voltar
          </Button>
        </Col>
      </Row>

      {mensagem && <Alert variant="success">{mensagem}</Alert>}
      {erro && <Alert variant="danger">{erro}</Alert>}
    </div>
  );
};

export default FeriadosInclusaoComponent;
